"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function CheckCircleFilled(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z M10.6735527,5.66200519 L7.552,8.783 L5.7286024,6.95939052 L4.66794223,8.0200507 L7.55238486,10.9044933 L11.7342128,6.72266536 L10.6735527,5.66200519 Z" })));
}
exports.default = CheckCircleFilled;
//# sourceMappingURL=CheckCircleFilled.js.map